import React, {useEffect} from "react";
import {getAuth, onAuthStateChanged} from "@firebase/auth";
import {useNavigate} from "react-router";

function AuthCheck() {
  const navigate = useNavigate();
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        navigate('/login');
        return;
      }
    });
  });
  return (
      <></>
  )
}

export default AuthCheck;